// extracted by mini-css-extract-plugin
export default {"header":"header_header__UKyNZ","animate":"header_animate__e7Jg7","h1":"header_h1__NYTEN"};